let counter = 0

export const blockPage = () => {
  const root = typeof document !== 'undefined'
    ? document.getElementById('root')
    : undefined

  counter += 1

  if (root && counter === 1) {
    root.style.top = `-${window.scrollY}px`
    root.style.left = '0'
    root.style.right = '0'
    root.style.position = 'fixed'
    root.style.pointerEvents = 'none'

    window.scrollTo({
      behavior: 'instant',
      top: 0,
    })
  }
}

export const unblockPage = () => {
  const root = typeof document !== 'undefined'
    ? document.getElementById('root')
    : undefined

  counter -= 1

  if (root && counter === 0) {
    const scrollTop = Math.abs(parseInt(root.style.top, 10))

    root.style.position = ''
    root.style.left = ''
    root.style.right = ''
    root.style.top = ''
    root.style.pointerEvents = ''

    window.scrollTo({
      behavior: 'instant',
      top: scrollTop,
    })
  }

  counter = Math.max(counter, 0)
}
